module.exports = __webpack_public_path__ + "static/fish-cells-1-cbbee605d7ca66805e206f60ab671118.png";